(function ($) {
   $(function () {
      $('.nav-dropdown-button').each(function () {
         const $this = $(this);
         $this.on('click', function () {
            const $parent = $this.closest('.navigation-dropdown');
            if ($parent.hasClass('open')) {
               $parent.removeClass('open');
            } else {
               $parent.addClass('open');
            }
         });
      });
   });
})(jQuery);
